namespace $.$$ {

	export class $bog_smalljs_landing extends $.$bog_smalljs_landing {

		/**
		 * Три файла витрины — это буквально пример `hello` из песочницы, а не его
		 * пересказ. Кнопка «Попробовать» рядом открывает песочницу на нём же, и
		 * читатель попадает в тот самый код, который только что прочёл. Держать
		 * вторую копию значило бы однажды поправить одну из них.
		 *
		 * Живое демо справа — $bog_smalljs_demo, ручной двойник этого примера:
		 * то же поле, то же приветствие, но в теме сайта.
		 *
		 * Примеры лежат в $bog_smalljs_playground — упоминаем модуль здесь, чтобы
		 * сборщик увидел зависимость: имя константы длиннее имени папки и само по
		 * себе в граф не разбирается.
		 */
		sample() {
			return $bog_smalljs_playground_samples.hello
		}

		/** Разметка: что показано, из чего собрано. */
		code() {
			return this.sample().tree.trimEnd()
		}

		/**
		 * Второй файл витрины. Без него `greeting` в дереве остался бы статической
		 * строкой: ввод в поле ничего бы не менял, а живое демо справа — меняет.
		 * Показывать одно дерево значило обещать поведение, которого показанный
		 * код не даёт.
		 */
		code_ts() {
			return this.sample().ts.trimEnd()
		}

		/**
		 * Третий файл. Фронтендер, впервые увидевший $mol, первым делом
		 * спрашивает, чем тут пишут стили — и уходит гадать, если ответа рядом
		 * нет. Это он: обычный TypeScript, свойства проверяются типами.
		 */
		code_css() {
			return this.sample().css.trimEnd()
		}

		/**
		 * Раскладка, которая есть у любого проекта на $mol, урезанная до строк,
		 * отвечающих на вопрос «куда класть свой код»: воркспейс, фреймворк рядом,
		 * ваш пакет и один проект внутри со своим репозиторием. В доках то же дерево
		 * показано вместе с файлами модуля — здесь речь про владение, а не про файлы.
		 *
		 * Собирается строками, а не разметкой: компонент разбирает ровно тот листинг,
		 * который читатель скопировал бы из доков. Подписи — локализуемые, пути — нет.
		 */
		arch_tree() {
			const rows: readonly ( readonly [ string, string ] )[] = [
				[ 'mam/', this.arch_label_workspace() ],
				[ '├── .meta.tree', this.arch_label_registry() ],
				[ '├── mol/', this.arch_label_framework() ],
				[ '└── my/', this.arch_label_package() ],
				[ '    ├── my.meta.tree', this.arch_label_registry_own() ],
				[ '    └── hello/', this.arch_label_project() ],
				[ '        ├── index.html', this.arch_label_entry() ],
				[ '        └── hello.view.tree', this.arch_label_tree() ],
			]
			// Два пробела и больше — граница имени и подписи для разборщика дерева.
			const width = Math.max( ... rows.map( ( [ path ] ) => path.length ) ) + 2
			return rows.map( ( [ path, note ] ) => note ? path.padEnd( width ) + note : path ).join( '\n' )
		}

	}

}
